module.exports = __webpack_public_path__ + "img/icon-watched-on.393efd0d.svg";